<template lang="pug">
  div.select_options(:class="{disabled: disabled,readonly: readonly, noCheckBox:!select.showCheckBox, checked: checked, d_row: select.direction !== 'column'}" @click.stop.prevent="handleClick")
    slot
      div.option_warp
        span(v-if="select.showCheckBox")
          i.icon(v-show="!checked")
          i.icon.checked(v-show="checked")
        span.contentLabel {{label || value}}
</template>

<script>
import emitter from '../../src/mixins/emitter.js'
export default {
  name: 'km-select-option',
  inject: ['select'],
  mixins: [emitter],
  props: {
    disabled: {
      default: false
    },
    value: {
      required: true
    },
    label: '',
    readonly: {
      default: false
    }
  },
  data() {
    return {
      isByClick: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled && !this.readonly) {
        this.isByClick = true
        this.dispatch('kmSelect', 'select', [this, !this.checked])
      }
    },
    contains(arr = [], value) {
      if (this.select.multiple && arr instanceof Array) {
        return arr.includes(value)
      }
      return this.select.value === value
    }
  },
  computed: {
    checked(value) {
      return !this.disabled && this.contains(this.select.value, this.value)
    }
  },
  watch: {
    checked: {
      immediate: true,
      handler() {
        if (this.isByClick) {
          this.isByClick = false
        } else {
          this.dispatch('kmSelect', 'select', [this, this.checked])
        }
      }
    },
    value(v, old) {
      if (this.contains(this.select.value, old)) {
        this.dispatch('kmSelect', 'deleteSelect', [this])
      }
    }
  },
  beforeDestroy() {
    if (this.checked) {
      this.dispatch('kmSelect', 'deleteSelect', [this])
    }
  }
}
</script>

<style lang="less" scoped>
.select_options {
  cursor: pointer;
  padding-left: 10px;
  line-height: 24px;
}
i.icon {
  display: block;
  width: 16px;
  height: 16px;
  background-image: url(/static/images/icon_common.png);
}
i.icon.checked {
  background-position-x: -16px;
}
.d_row {
  display: inline-block;
  padding: 0 6px;
  color: #21bd73;
  margin-left: 4px;
  margin-right: 4px;
}
.disabled,
.readonly {
  cursor: not-allowed;
  color: #aaa;
  * {
    cursor: not-allowed;
    color: #aaa;
  }
}
.noCheckBox:hover {
  background: #f2f9f6;
}
.noCheckBox.checked {
  background: #24cc7c;
  color: white;
}
.option_warp {
  display: flex;
  align-items: center;
}
.contentLabel {
  margin-left: 6px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/ui/components/km-select/select-option.vue